import { Lang } from './Lang'
import { RightMenu } from './RightMenu'

export const Component = { RightMenu, Lang }
